'use strict';

import Hook from './Hook.js';
import SignUpStep from './SignUpStep.js';
import DefaultFields from './DefaultFields.js';
import ManageSteps from './ManageSteps.js';
import TeamsFlows from './TeamsFlows.js';
import P2PFlows from './P2PFlows.js';
import { DOM } from '../../helpers/DOM.js';
import { __ } from '@wordpress/i18n';

import CRMFlow from "./CRMFlow.js";
import { ChoiceSelect} from "../ChoiceSelect.js";
import {restrict_movements_over_cc} from '../../utils/PhoneField.js';
import { syncChoicesSelectValue } from '../../helpers/ChoicesSelectValue.js';

export class MultiStepForms{

    formWrapper = null;
	gamification = null;
    formSteps = [];
    currentStep = 1;
    stepsCount = 1;
    previousStep = null;

    childClasses = {};

	/**
	 * @type {Hook}
	 */
	Hook;

	#sentSubmitRequest = false;

    constructor () {
        this.formWrapper = document.querySelector('.levcharity-multi-step-form-wrapper');
		this.gamification = this.formWrapper?.getAttribute('data-gamification');
		const choices = new ChoiceSelect();
		choices.multiSelect('.choose-equipment-multiple-choices');
        if (this.formWrapper) {
            this.Hook = new Hook();

            this.formSteps = [...this.formWrapper.children];
            this.currentStep = parseInt(this.formWrapper?.dataset?.startStep || 1);
            this.stepsCount = this.formSteps.length;

            this.childClasses = {
                DefaultFields: new DefaultFields(this),
                SignUpStep: new SignUpStep(this),
                ManageSteps: new ManageSteps(this),
            };

            if (document.querySelector('.levcharity-multi-step-form-wrapper.team-campaigns')){
                this.childClasses.TeamsFlows = new TeamsFlows(this);
            }

            if (document.querySelector('.levcharity-multi-step-form-wrapper.p2p-campaigns')){
                this.childClasses.P2PFlows = new P2PFlows(this);
            }

			if (document.querySelector('.levcharity-multi-step-form-wrapper.crm')) {
				this.childClasses.CRMFlow = new CRMFlow(this);
			}

            this.#addEvents();
            this.#addWatchers();

			this.Hook.doAction('init');

			this.#addFilters();
			this.#addActions();
        }
    }

	#addFilters() {
		this.Hook.addFilter('sendSubmitRequest', (canSubmit, form, formAction) => {
			if (this.#sentSubmitRequest) {
				return false;
			}

			return canSubmit;
		})
	}

	#addActions() {

		this.Hook.addAction('beforeSubmitRequestSent', (sendSubmitRequest, form, formAction) => {
			this.#sentSubmitRequest = true;
		});

		this.Hook.addAction('submitFormAfterSubmit', (form, formAction) => {
			this.#sentSubmitRequest = false;
		});

		this.Hook.addAction('submitFormSuccess', (response, form, formAction) => {
			if (response?.redirect_url) {
				setTimeout(() => {
					window.location = response.redirect_url
				}, 200)
			}
		});

		this.Hook.addAction('submitFormFail', (response, form, formAction) => {
			if (response?.redirect_url) {
				setTimeout(() => {
					window.location = response.redirect_url
				}, 200)
			}
		});
	}

    #addEvents() {
        this.Hook.doAction('addEvents');
		if(this.gamification){
			this.#liveValidateFields()
		}
    }

    #addWatchers() {
        this.Hook.doAction('addWatchers')
    }

    observeElements (selector, elementCallback) {
        return DOM.observeElements(selector, elementCallback);
    }

    handleEvent(event, selector, callback, eventElement = null) {
		let element = null;

		if (eventElement) {
			element = eventElement;
		} else {
			element = this.formWrapper;
		}

		return DOM.addEvent(event, selector, callback, element);
    }

    element(element, selector) {
        return DOM.compareElement(element, selector);
    }

    async error(field, text = '',form = null, scrollTop = true, live = false) {
        field?.classList?.add('error');


        if (field && form === null){
            form = field.closest('form')
        }

        if (field?.closest('.review-wrapper')) {
            field.closest('.form-group')?.classList.add('error')
        }

        if (field?.closest('.choices')){
            field.closest('.choices').classList.add('error')
        }

		if(field?.closest('.button-image')){
			field.closest('.button-image').querySelector('.button-image-upload').classList.add('error')
		}

		text = this.Hook.applyFilters('errorMessage', text, field, form);
		// const errorWrapperUnderField = DOM.el('.levcharity_error_message', field.closest('.form-field'))
		const passwordValidationWrapper = DOM.el('.password-validation-wrapper');
		if (live && form) {

			if (!errorWrapperUnderField) {
				const existingError = passwordValidationWrapper?.querySelector(`.live-error[data-field="${field.name}"]`);

				if (existingError) {
					existingError.remove();
				}

				const errorParagraph = DOM.create('p', {className: 'live-error', dataField: field.name});
				errorParagraph.textContent = text;

				passwordValidationWrapper?.insertAdjacentElement('afterbegin', errorParagraph);
			} else {
				errorWrapperUnderField.innerHTML = '';
				const errorParagraph = DOM.create('span', {className: 'live-error', dataField: field.name});
				errorParagraph.textContent = text;

				errorWrapperUnderField?.insertAdjacentElement('afterbegin', errorParagraph);
			}
		}



		if (form?.querySelector('.levcharity-errors-container') && text && live === false) {
			const errorContainer = form.querySelector('.levcharity-errors-container');
			const existingMessages = Array.from(errorContainer.querySelectorAll('.error-message'));

			const uniqueId = `error-${text.replace(/\s+/g, '-').toLowerCase()}${new Date().getTime()}`;

			const isDuplicate = existingMessages.some(message => message.id === uniqueId);



			if (!isDuplicate) {
				errorContainer.insertAdjacentHTML('afterbegin', `<p id="${uniqueId}" class="error-message" style="display:none">${text}</p>`);

				if(window.levToast){
					window.levToast.error(text)
				}else{
					const {Notifications} = await import(/* webpackChunkName: "notifications" */ '../../helpers/Notifications.js')

					new Notifications()
						.setMessage(text)
						.setType('error')
						.setTimeout(15000)
						.execPopup();
				}

				if (!field && scrollTop){
					window.scrollTo(0,0);
				}
			}
        }
		if (!field && scrollTop) {
			window.scrollTo(0, 0);
		}
    }

    clearErrors(field = null) {
		const errorContainer = this.formWrapper.querySelector('.levcharity-errors-container');
        const errorFields = this.formWrapper.querySelectorAll('.error');
		errorContainer.innerHTML = '';
        for (const field of errorFields) {
            field.classList.remove('error');
        }

		const passwordValidationWrapper = DOM.el('.password-validation-wrapper');
		if(field){
			field.classList.remove('error');
			const errors = passwordValidationWrapper.querySelectorAll('.live-error');
			errors.forEach(error => {
				if(error.getAttribute('data-field') === field.name){
					error.remove();
				}
			})
		}
    }

	/**
	 * Fetch a fresh create-user nonce from uncached admin-ajax so FastCGI / page
	 * cache cannot leave a stale value in the signup form HTML.
	 */
	async #refreshCreateUserNonce(form) {
		try {
			const response = await fetch(
				`${admin_ajax[0]}?action=levcharity_create_user_nonce&_=${Date.now()}`,
				{
					method: 'GET',
					credentials: 'same-origin',
					cache: 'no-store',
				}
			);
			const data = await response.json();
			if (data?.success && data?.nonce) {
				const nonceInput = form.querySelector('input[name="levcharity_create_user_nonce"]');
				if (nonceInput) {
					nonceInput.value = data.nonce;
				}
			}
		} catch (e) {
			// Keep the existing form nonce if refresh fails.
		}
	}

	#setCreateUserNonce(form, formData, nonce) {
		if (!nonce) {
			return;
		}
		const nonceInput = form.querySelector('input[name="levcharity_create_user_nonce"]');
		if (nonceInput) {
			nonceInput.value = nonce;
		}
		formData.set('levcharity_create_user_nonce', nonce);
	}

    async submitForm(form, action, addLoader = true) {

		if (action === 'levcharity_create_user') {
			await this.#refreshCreateUserNonce(form);
		}

		let formData = new FormData(form);

		const maxUploadBytes = 5 * 1024 * 1024;
		for (const [name, value] of formData.entries()) {
			if (value instanceof File && value.size > maxUploadBytes) {
				const sizeLabel = `${Math.round(maxUploadBytes / (1024 * 1024))}MB`;
				const message = typeof wp !== 'undefined' && wp.i18n
					? wp.i18n.sprintf(
						wp.i18n.__('This image is too large. Please choose a file under %s.', 'levcharity'),
						sizeLabel
					)
					: `This image is too large. Please choose a file under ${sizeLabel}.`;
				return Promise.reject({ success: false, message });
			}
		}

        if (this.formWrapper.classList.contains('crm')) {
			const wrapper = this.formWrapper.querySelector('.levcharity_default_fields_wrapper');
			if (wrapper) {
				const defaultFieldsContainer = new FormData();

				const defaultFieldsInputs = wrapper.querySelectorAll('input[name], select[name], textarea[name]');
				defaultFieldsInputs.forEach(input => {
					if (input.name && input.value) {
						const name = `default_fields[${input.name}]`;
						if (input.type === 'radio') {
							if (input.checked) {
								defaultFieldsContainer.append(name, input.value);
							}
						} else if (input.type === 'file') {
							defaultFieldsContainer.append(name, input.files[0]);
						} else {
							defaultFieldsContainer.append(name, input.value);
						}
						formData.delete(input.name);
					}
				});

				defaultFieldsContainer.forEach((value, name) => {
					formData.append(name, value);
				});
			}
		}


        return await new Promise(async (resolve, reject) => {

            if (addLoader && !document.body.classList.contains('ajax-loading')) {
                document.body.classList.add('ajax-loading');
            }

			const postSignup = () => fetch(
                `${admin_ajax[0]}?action=${action}`,
                {
                    method: 'POST',
                    body: formData,
					credentials: 'same-origin',
					cache: 'no-store',
                }
            );

			const parseJsonResponse = async (response) => {
                const contentType = response.headers.get('content-type') || '';
                if (!contentType.includes('application/json')) {
                    throw {
                        success: false,
                        message: typeof wp !== 'undefined' && wp.i18n
                            ? wp.i18n.__('Upload failed. The file may be too large or the request timed out. Please try a smaller image.', 'levcharity')
                            : 'Upload failed. The file may be too large or the request timed out. Please try a smaller image.',
                    };
                }
                return response.json();
			};

			let retriedCreateUserNonce = false;

            await postSignup()
            .then(parseJsonResponse)
            .then(async (response) => {
				if (
					!response?.success &&
					action === 'levcharity_create_user' &&
					response?.nonce &&
					!retriedCreateUserNonce
				) {
					retriedCreateUserNonce = true;
					this.#setCreateUserNonce(form, formData, response.nonce);
					response = await parseJsonResponse(await postSignup());
				}

                if (response?.success) {
					const participateUrl =
						response?.data?.participate_url || response?.participate_url;
					const participantLink =
						participateUrl && participateUrl.length > 0
							? participateUrl
							: (response?.data?.participant_link || response?.participant_link) &&
							  (response?.data?.participant_link || response?.participant_link).length > 0
							? response?.data?.participant_link || response?.participant_link
							: null;

					if (participantLink) {
						const thankYouStep = document.querySelector('.thank-you-step[data-fallback-url]');
						if (thankYouStep) {
							const fallback = thankYouStep.getAttribute('data-fallback-url') || '';
							const campaignUrl = thankYouStep.getAttribute('data-campaign-url') || '';
							const stripTrailingSlash = (value) => (value || '').replace(/\/+$/, '');

							if (
								campaignUrl &&
								stripTrailingSlash(participantLink) === stripTrailingSlash(campaignUrl)
							) {
								participantLink = fallback || participantLink;
							}
						}

						try {
							sessionStorage.setItem('levcharity_signup_participant_url', participantLink);
						} catch (e) {
							// ignore
						}

						const teamId = response?.data?.team_id ?? response?.team_id;
						if (teamId) {
							try {
								sessionStorage.setItem('levcharity_signup_team_id', String(teamId));
							} catch (e) {
								// ignore
							}
						}

						const thankYouStepLinks = document.querySelectorAll(
							'.thank-you-step .team_campaign_participant_url, .thank-you-step .view_page_button, .thank-you-step .fields-container > a.levcharity_button.primary_button'
						);
						thankYouStepLinks.forEach((link) => {
							link.href = participantLink;
						});

						const shareLinks = document.querySelectorAll('.thank-you-step .wp-block-custom-inline-social-share-levit-block .list a');
						if (shareLinks.length > 0) {
							const baseUrl = participantLink.replace(/\/$/, '');
							shareLinks.forEach(link => {
								link.href = link.href.replace(window.location.origin, baseUrl);
							});
						}
					}
					if ( action === 'levcharity_regular_signup' && [ 'individual', 'join_team', 'create_team', 'join-team', 'create-team' ].includes(formData.get( 'signup_action' ))) {
						document.dispatchEvent(
							new CustomEvent( 'levcharityJoinTeamCompleted', {
								detail: response,
							} )
						);
					}
                    resolve(response)
                } else {
                    reject(response);
                }
            })
            .catch(response => {
                reject(response);
            })
            .finally(() => {
                if (document.body.classList.contains('ajax-loading')) {
                    document.body.classList.remove('ajax-loading');
                }
            });
        });
    }

	validateVideoUrlField(url){
		const videoExtensions = /\.(mp4|mov|wmv|avi|flv|webm|mkv|mpg)$/i;
		const videoPlatformsPattern = /^(https?:\/\/)?(www\.)?(youtube|vimeo)\.(com|be)\/(.*)$/i;
		return videoExtensions.test(url) || videoPlatformsPattern.test(url);
	}

	formatFieldNameForError(fieldName = '') {
		const normalizedFieldName = String(fieldName)
			.replace(/^cf\[/i, '')
			.replace(/\]$/i, '')
			.replace(/^scf[_\s-]*/i, '')
			.replace(/\[/g, ' ')
			.replace(/\]/g, ' ')
			.split(/[-_]/)
			.filter(n => n)
			.join(' ')
			.replace(/\s+/g, ' ')
			.trim();

		return normalizedFieldName
			? normalizedFieldName.replace(/^\w/g, char => char.toUpperCase())
			: 'Field';
	}


	validateFields(form) {
		form.querySelectorAll('select[name="chaination_event_city"]').forEach((select) => {
			syncChoicesSelectValue(select);
		});

        const fields = form.querySelectorAll('input,textarea,select');

        const letterRegex = /[a-zA-Z]/;
        const numberRegex = /\d/;
		const symbolRegex = /[!@#$%^&*()_+{}\[\]:;<>,.?/~\\\-=`]/;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        let password = false;
        let passwordField = false;
        let confirmPassword = false;

        let isValid = true;

		const radioFields = [];
		let predefinedBannerImageValue = "";
		let bannerImageFileChosen = false;

        for (const field of fields) {
            if (field.disabled) continue;

			if (field.name==="camp-select" && !field.value){
				let field_value  = 	field.getAttribute('data-selected-team-id');

				if (field_value > 0){
					field.value = field_value
				}else{
					let selectable = DOM.el('.choices__item--selectable');
					if (selectable){
						field.value = selectable.getAttribute('data-value');
					}
				}
			}



			if (field.name === 'predefined_banner_image' && field.type === 'radio') {
				if (field.checked) {
					predefinedBannerImageValue = field.value;
				}
			}
			if (field.name === 'banner_image' && field.type === 'file') {
				if (field.files && field.files.length > 0) {
					bannerImageFileChosen = true;
				}
			}

            if (field.required && (field.type === 'checkbox' || field.type === 'radio') && !field.checked){
				let displayError = true;
				if (field.type === 'radio') {
					this.formWrapper.querySelectorAll(`input[type="radio"][name="${field.name}"]`)
						.forEach(el => {
							if (el.checked) {
								displayError = false;
							}
						})
				}

				if (displayError && (field.type !== 'radio' || !radioFields.includes(field.name))) {
					if (field.type === 'radio') radioFields.push(field.name);
					const formattedFieldName = this.formatFieldNameForError(field.name);
					this.error(field, wp.i18n.__(formattedFieldName + ' shouldn\'t be empty.', 'levcharity'));
					isValid = false;
				}
            }

			if(this.gamification){
				if(field.name === 'phone_number'){
					const fullNumberLength = field.getAttribute('data-full-number-length');
					if(field.value.length > 3){
						if(field.value.length - 2 !== Number(fullNumberLength)){
							this.error(field, wp.i18n.__('Write your full number', 'levcharity') )
							isValid = false;
						}
					}
				}else if(field.name === 'team_id' && !field.value ){
                    if (field.tagName.toLowerCase() === 'select'){
						this.error(field, wp.i18n.__('Team shouldn\'t be empty. ', 'levcharity') )
						isValid = false;
						continue
					}

				}
			}


			if(field.name === 'video_url'){
				if(!this.validateVideoUrlField(field.value) && field.value.length){
					this.error(field, wp.i18n.__('Wrong Video URL, please set correct URL', 'levcharity'));
					isValid = false;
				}
			}



            if (field.required && !field.value) {
				if(this.gamification){
					if(field.name === "banner_image") continue;
				}
				const formattedFieldName = this.formatFieldNameForError(field.name);
                this.error(field, wp.i18n.__(formattedFieldName + ' shouldn\'t be empty.', 'levcharity'));
                isValid = false;
            } else if (['password', 'confirm-password'].includes(field.dataset.type)) {
                if ((!letterRegex.test(field.value) || !numberRegex.test(field.value) || !symbolRegex.test(field.value) || field.value.length < 7) && (!field.dataset?.type || field.dataset?.type && field.dataset.type === 'password')) {
                    this.error(field, wp.i18n.__('Password is not valid', 'levcharity'));
                    isValid = false;
                }

                if (field.dataset && field.dataset.type === 'password') {
					passwordField = field;
                    password = field.value;
                } else if (field.dataset && field.dataset.type === 'confirm-password') {
                    confirmPassword = field.value;
                }
            } else if (field.type === 'email') {
                if (field.value && !emailRegex.test(field.value)) {
                    this.error(field, wp.i18n.__('Email address is not valid.', 'levcharity'));
                    isValid = false;
                }
            } else if(['team_campaign_goal_other_amount', 'campaign_goal_other_amount', 'fundraising_campaign_goal_other_amount'].includes(field.name)){
				if (field?.value !== '' && field?.value < 1){
					this.error(field, wp.i18n.__('Goal amount must be greater than 1.', 'levcharity'));
					isValid = false;
				} else if (field?.value !== '' && field?.dataset?.minCustomGoal) {
					const minCustomGoal = parseFloat(field.dataset.minCustomGoal);
					if (!isNaN(minCustomGoal) && minCustomGoal > 0 && parseFloat(field.value) < minCustomGoal) {
						const message = wp.i18n.__('The minimum fundraising goal is $%1$s. Please enter a goal of at least $%1$s.', 'levcharity').replace(/%1\$s/g, String(minCustomGoal));
						this.error(field, message);
						isValid = false;
					}
				}
			} else if(field.name == 'campaign_end'){
				const campaign_start_el = document.querySelector('[name=campaign_start]')
				if(campaign_start_el){
					const start_date = new Date(campaign_start_el.value)
					const end_date = new Date(field.value)
					const current_date = new Date()

					if(end_date.getTime() < current_date.getTime()){
						this.error(field, wp.i18n.__('End date cannot be earlier than current date', 'levcharity'));
						isValid = false;
					}
					else if(end_date.getTime() < start_date.getTime()){
						this.error(field, wp.i18n.__('End date cannot be earlier than start date', 'levcharity'));
						isValid = false;
					}
				}
			}

			if(field.name === 'video_url' && field.required){
				if(!this.validateVideoUrlField(field.value) && field.value.length){
					this.error(field, wp.i18n.__('Wrong Video URL, please set correct URL', 'levcharity'));
					isValid = false;
				}
			}

		}

		// if(this.gamification){
		// 	if(form.id === 'teams-3'){
		// 		if (!predefinedBannerImageValue && !bannerImageFileChosen) {
		// 			const fieldToMark = [...fields].find(field => field.name === 'predefined_banner_image') || fields[0];
		// 			this.error(fieldToMark, wp.i18n.__('Either a predefined banner image must be selected or a banner image file must be uploaded.', 'levcharity'));
		// 			isValid = false;
		// 		}
		// 	}
		// }


        if (password !== false && confirmPassword !== false && password !== confirmPassword) {
            this.error(passwordField, wp.i18n.__('Password Mismatch.', 'levcharity'), form);
            isValid = false;
        }

        return isValid;
    }

	#liveValidateFields(){
		const letterRegex = /[a-zA-Z]/;
		const numberRegex = /\d/;
		const symbolRegex = /[!@#$%^&*()_+{}\[\]:;<>,.?/~\\\-=`]/;
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		const form = DOM.el('form.signup-form');
		const fields = form?.querySelectorAll('input,textarea,select');
		let password = false;
		let confirmPassword = false;

		let isValid = true;
		for (const field of fields) {
			if (field.dataset && field.name === 'password') {
				DOM.addEvent('blur', field, () => {
					if ((!letterRegex.test(field.value) || !numberRegex.test(field.value) || !symbolRegex.test(field.value) || field.value.length < 7) && (!field.dataset?.type || field.dataset?.type && field.dataset.type === 'password') && (field.value.length > 0)) {
						this.error(field, wp.i18n.__('Password is not valid', 'levcharity'), null, true, true);
						isValid = false;
					}else{
						this.clearErrors(field);
						password = field.value;
					}
				})
			}
			if (field.type === 'email') {
				DOM.addEvent('blur', field, () => {
					if (field.value && !emailRegex.test(field.value) && (field.value.length > 0)) {
						this.error(field, wp.i18n.__('Email address is not valid.', 'levcharity'), null, true, true);
						isValid = false;
					}else{
						const errorWrapperUnderField = DOM.el('.levcharity_error_message', field.closest('.form-field'))
						errorWrapperUnderField.innerHTML = '';
						field.classList.remove('error');
					}
				})
			}
			if(field.name === 'confirm-password'){
				DOM.addEvent('blur', field, () => {

					confirmPassword = field.value;
					if (password !== false && confirmPassword !== false && password !== confirmPassword && (confirmPassword.value.length > 0)) {
						this.error(field, wp.i18n.__('Passwords is not matched', 'levcharity'), null, true, true);
						isValid = false;
					}else{
						this.clearErrors(field);
					}
				})
			}


		}
	}

	#liveValidateFieldsWithoutGamification(){
		const form = document.querySelector('form.signup-form');
		const phone_number_field = form ? document.querySelector('[name="phone_number"]') : '';

		if(phone_number_field) {
			// make hand off from country code
			phone_number_field.addEventListener('keydown', e => restrict_movements_over_cc(e, phone_number_field))
			phone_number_field.addEventListener('focus', e => restrict_movements_over_cc(e, phone_number_field))
		}
	}

    setCookie(name, value, daysToExpire) {
        var expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + daysToExpire);

        document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expirationDate.toUTCString() + '; path=/';
    }

    getCookie(name) {
        var cookies = document.cookie.split(';');

        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();

            if (cookie.indexOf(name + '=') === 0) {
                return decodeURIComponent(cookie.substring(name.length + 1));
            }
        }

        return null;
    }
}
